
import { Component, Provide, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'

@Component({
  name: 'AppMain'
})
export default class extends Vue {
  get cachedViews () {
    return TagsViewModule.cachedViews
  }

  get key () {
    return this.$route.path
  }

  private isRouterAlive = !0

  @Provide()
  reload = () => {
    this.setRouterAlive(false)
    this.$nextTick(() => {
      this.setRouterAlive(true)
    })
  }

  private setRouterAlive (flag: boolean) {
    this.isRouterAlive = flag
  }
}
